import routerOptions0 from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}